import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from './core/services/globals.service';
import { LanguageService } from './core/services/language.service';
import { SeoService } from './core/services/seo.service';
import { environment } from '../environments/environment';

declare const Stats: any;

@Component({
    selector: 'gl-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private languageService: LanguageService,
    private seoService: SeoService,
    private globalsService: GlobalsService,
  ) {
    const lang = this.languageService.getDefaultLanguage();
    this.translate.setDefaultLang(lang);
    this.seoService.init();
    this.globalsService.init();
    if (environment.isThreeStats) {
      this.launchThreeStats();
    }
  }

  private launchThreeStats(): void {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    (function (): void {
      const script: HTMLScriptElement = document.createElement('script');
      script.onload = function (): void {
          const stats = new Stats();
          stats.dom.style.position = 'fixed';
          stats.dom.style.left = '0px';
          stats.dom.style.top = 'auto';
          stats.dom.style.bottom = '0px';
          document.body.appendChild(stats.dom);
          requestAnimationFrame(function loop() {
            stats.update();
            requestAnimationFrame(loop);
          });
      };
      script.src = '//mrdoob.github.io/stats.js/build/stats.min.js';
      document.head.appendChild(script);
    })();
  }
}
